import LocalData from './utils/LocalData';
import Tween from './utils/Tween';
import Ripple from './utils/Ripple';
import Platform from './utils/Platform';
import ScrollControler from './utils/ScrollControl';
import Adaptation from './utils/Adaptation';
import { readXLSX, excelExport, generateXLSXFile } from './utils/xlsx';
import Browser from './Browser';

import {
  isCssPropertySupported,
  getElementStyle,
  getElementPosition,
  getScrollTop,
  isLessThenIE8,
  loadScript,
  downloadBlob,
  createScriptUrl,
  preventDefaultEvent,
  allowDefaultEvent,
  objectToUrlParams,
  urlParamsToObject,
  imgSrcToBase64Uri,
  copyToClipboard,
  readBlobAsDataURL,
  getElement,
  dataURLToBlob,
  blobToUrl,
  getElementScrollTop,
  preventDefault,
  getScroller,
} from './utils/index';

export {
  Tween,
  LocalData,
  excelExport,
  Ripple,
  Platform,
  Adaptation,
  ScrollControler,
  Browser,
  isCssPropertySupported,
  getElementStyle,
  getElementPosition,
  getScrollTop,
  isLessThenIE8,
  loadScript,
  downloadBlob,
  createScriptUrl,
  preventDefaultEvent,
  allowDefaultEvent,
  objectToUrlParams,
  urlParamsToObject,
  imgSrcToBase64Uri,
  copyToClipboard,
  readBlobAsDataURL,
  getElement,
  generateXLSXFile,
  readXLSX,
  dataURLToBlob,
  blobToUrl,
  getElementScrollTop,
  preventDefault,
  getScroller,
};

export default {
  Tween,
  LocalData,
  excelExport,
  Ripple,
  Platform,
  Adaptation,
  ScrollControler,
  Browser,
  isCssPropertySupported,
  getElementStyle,
  getElementPosition,
  getScrollTop,
  isLessThenIE8,
  loadScript,
  downloadBlob,
  createScriptUrl,
  preventDefaultEvent,
  allowDefaultEvent,
  objectToUrlParams,
  urlParamsToObject,
  imgSrcToBase64Uri,
  copyToClipboard,
  readBlobAsDataURL,
  getElement,
  generateXLSXFile,
  readXLSX,
  dataURLToBlob,
  blobToUrl,
  getElementScrollTop,
  preventDefault,
  getScroller,
};
